import { Api } from "./api"

const PATH = 'frais-abonnement' 
const ENDPOINTS = {
    Liste:'liste',
    Store:'store',
    Show:'show',
    Update:'update',
    Delete:'delete',
    Activate:'activate',
}

export const FraisAbonnementApi = {
    getFraisAbonnement: (signal) => Api.get(`${PATH}/${ENDPOINTS.Liste}`, signal),
    createFraisAbonnement: (payload, signal) => Api.post(`${PATH}/${ENDPOINTS.Store}`, payload, signal),
    updateFraisAbonnement: (id, payload, signal) => Api.update(`${PATH}/${ENDPOINTS.Update}/${id}`, payload, signal),
    deleteFraisAbonnement: (id, signal) => Api.erase(`${PATH}/${ENDPOINTS.Delete}/${id}`, signal),
    activateFraisAbonnement: (id, signal) => Api.post(`${PATH}/${ENDPOINTS.Activate}/${id}`, JSON.stringify({}), signal),
}